<h3>
  Resolution Center
</h3>
<div class="table-actions">
  <div class="table-actions-left">
    <mat-form-field class="action-field" appearance="fill">
      <mat-label>Action</mat-label>
      <mat-select [(ngModel)]="currentActionValue" (selectionChange)="onAction($event.value)">
        <mat-option value="" disabled>Select an action</mat-option>
        <mat-option value="Export">Export</mat-option>
        <mat-option value="Close">Close</mat-option>
        <mat-option value="Open">Open</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="search-field" appearance="fill">
      <mat-label>Search</mat-label>
      <input matInput [(ngModel)]="currentSearchValue" placeholder="Member ID, Name, or Notes" (input)="onSearch()" />
      <button *ngIf="currentSearchValue" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
        <i class="fa-duotone fa-solid fa-circle-xmark"></i>
      </button>
    </mat-form-field>

    <mat-form-field class="filter-field" appearance="fill">
      <mat-label>Filter</mat-label>
      <mat-select multiple
                  [(ngModel)]="currentFilterSelection"
                  (selectionChange)="onFilterChange()">

        <mat-optgroup label="Source">
          <mat-option value="PCP">PCP Only</mat-option>
          <mat-option value="HRAT">HRAT Only</mat-option>
          <mat-option value="Maternity">Maternity Only</mat-option>
        </mat-optgroup>

        <mat-optgroup label="Review Flags">
          <mat-option value="HasSpokeWith">Has Spoke With</mat-option>
          <mat-option value="HasLeftMessage">Has Left Message</mat-option>
          <mat-option value="HasSentLetter">Has Sent Letter</mat-option>
          <mat-option value="HasScheduledAppointment">Has Scheduled Appointment</mat-option>
          <mat-option value="HasNotes">Has Notes</mat-option>
        </mat-optgroup>

        <mat-optgroup label="Status">
          <mat-option value="STATUS:OPEN">Open Only</mat-option>
          <mat-option value="STATUS:CLOSED">Closed Only</mat-option>
        </mat-optgroup>

        <mat-optgroup label="Reprocess Reason">
          <mat-option *ngFor="let item of sortedReprocessReasonListItems"
                      [value]="'REPROC:' + item.name">
            {{ item.name }}
          </mat-option>
        </mat-optgroup>

        <mat-optgroup label="DCO Notes">
          <mat-option *ngFor="let item of dcoNotesListItems"
                      [value]="'NOTE:' + item.name">
            {{ item.name }}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>


    <mat-chip-set class="active-filters" *ngIf="hasActiveFilters()">
      <!-- Search Chip -->
      <mat-chip *ngIf="currentSearchValue && currentSearchValue.length >= 3"
                removable (removed)="clearSearch()">
        Search: "{{ currentSearchValue }}"
        <button mat-icon-button matChipRemove>
          <i class="fa-duotone fa-solid fa-circle-xmark"></i>
        </button>
      </mat-chip>

      <!-- Multi Filter Chips -->
      <ng-container *ngFor="let filterVal of currentFilterSelection">
        <mat-chip removable (removed)="removeFilterValue(filterVal)">
          Filter: {{ displayFilterName(filterVal) }}
          <button mat-icon-button matChipRemove>
            <i class="fa-duotone fa-solid fa-circle-xmark"></i>
          </button>
        </mat-chip>
      </ng-container>

      <!-- Clear All -->
      <mat-chip *ngIf="(currentSearchValue && currentSearchValue.length >= 3) || (currentFilterSelection?.length > 0)"
                removable (removed)="resetAllFilters()">
        Clear All
        <button mat-icon-button matChipRemove>
          <i class="fa-duotone fa-solid fa-circle-xmark"></i>
        </button>
      </mat-chip>
    </mat-chip-set>

    <mat-slide-toggle [(ngModel)]="filtersEnabled" (change)="applyFilter()" class="toggle-filter">
      Toggle Filters
    </mat-slide-toggle>

  </div>
  <div class="table-actions-right">
    <button mat-stroked-button (click)="toggleShowClosed()">
      <i class="fa-sharp-duotone" [ngClass]="{'fa-eye': showClosed, 'fa-eye-slash': !showClosed}"></i>
      {{ showClosed ? 'Hide Closed' : 'Show Closed' }}
    </button>
  </div>
</div>
<div class="table-wrapper">
  <table mat-table [dataSource]="referralsDataSource" class="mat-elevation-z8" *ngIf="referralsDataSource?.data?.length > 0; else noData" matSort (matSortChange)="onReferralsGridSortChange($event)">

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="isAllSelected()"
                      [indeterminate]="isIndeterminate()"
                      [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let referral">
        <mat-checkbox (click)="$event.stopPropagation()"
                      [checked]="selection.isSelected(referral)"
                      (change)="$event ? selection.toggle(referral) : null"
                      [aria-label]="checkboxLabel(referral)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="locked">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="locked"> Locked </th>
      <td mat-cell *matCellDef="let referral; let i = index">
        <ng-container *ngIf="referral.review?.isLocked">
          <i class="fa-duotone fa-lock"
             [ngClass]="{ 'clickable-lock': canForceUnlock(referral) }"
             [matTooltip]="getLockTooltip(referral, i)"
             matTooltipClass="multiline-tooltip"
             (click)="onLockClick(referral, i)">
          </i>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="memberId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="memberId"> DMAPID </th>
      <td mat-cell *matCellDef="let referral"> {{ referral.memberMedicaidId }} </td>
    </ng-container>

    <ng-container matColumnDef="memberName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="memberName"> Member Name </th>
      <td mat-cell *matCellDef="let referral"> {{ referral.memberFirstName }} {{ referral.memberLastName }}</td>
    </ng-container>

    <ng-container matColumnDef="receivedDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="receivedDate"> Received Date </th>
      <td mat-cell *matCellDef="let referral"> {{ referral.receivedDate | date }} </td>
    </ng-container>

    <ng-container matColumnDef="source">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="source"> Source </th>
      <td mat-cell *matCellDef="let referral"> {{ referral.referralType }}  </td>
    </ng-container>

    <ng-container matColumnDef="reprocessReason">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="reprocessReason"> Reprocess Reason </th>
      <td mat-cell *matCellDef="let referral; let i = index">
        <ng-container *ngIf="(selectedReferral?.id === referral.id); else displayValue">
          <select [(ngModel)]="referral.reprocessReason">
            <option *ngFor="let item of reprocessReasonListItems" [value]="item.name">
              {{ item.name }}
            </option>
          </select>
        </ng-container>
        <ng-template #displayValue>
          {{ referral.reprocessReason }}
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="dcoNote">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="dcoNote"> DCO Note </th>
      <td mat-cell *matCellDef="let referral">
        <div class="dco-note-cell" [matTooltip]="referral.review?.dcoNote || ''" matTooltipClass="multiline-tooltip">
          {{ referral.review?.dcoNote || '' }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let referral; let i = index">
        <div class="actions">
          <!-- Recheck -->
          <button type="button"
                  mat-raised-button
                  color="primary"
                  class="action-btn"
                  (click)="onRecheck(referral, i)"
                  [disabled]="referral.review?.isLocked"
                  [matTooltip]="referral.review?.isLocked ? 'Locked — open details to view' : 'Recheck (validate & review)'"
                  aria-label="Recheck">
            <i class="fa-light fa-rectangle-history-circle-user"></i>Recheck
          </button>

          <!-- Resubmit -->
          <button type="button"
                  mat-raised-button
                  color="accent"
                  class="action-btn"
                  (click)="onResubmit(referral, i)"
                  [disabled]="referral.review?.isLocked"
                  [matTooltip]="referral.review?.isLocked ? 'Locked — cannot resubmit' : 'Resubmit for processing'"
                  aria-label="Resubmit">
            <i class="fa-light fa-repeat"></i>Resubmit
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns;"
        [ngClass]="{'row-closed': row.review?.isClosed, 'active': selectedReferral?.id === row.id && !row.review?.isClosed}"
        [attr.disabled]="row.review?.isClosed ? '' : null">
    </tr>


  </table>
  <div class="paginator-wrap">
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"
                   aria-label="Select page of referrals"
                   showFirstLastButtons>
    </mat-paginator>

    <!-- overlayed summary; does NOT shrink the paginator -->
    <div class="paginator-overlay" *ngIf="filteredCount() > 0">
      <span class="sel-summary">
        <strong>{{ selectedInFilteredCount() }}</strong> selected / {{ filteredCount() }} total
        <span hidden class="page-summary" *ngIf="pageCount() > 0"> • {{ selectedOnPageCount() }} on this page</span>
      </span>

      <button mat-button
              class="clear-sel clickable"
              *ngIf="selection.hasValue()"
              (click)="selection.clear()">
        Clear selection
      </button>
    </div>
  </div>

  <!-- No Records Template -->
  <ng-template #noData>
    <div class="no-data-message">
      <h4>No records to show</h4>
      <p>There are currently no records available or the applied filter(s) returned no results.</p>
    </div>
  </ng-template>

</div>
